import apiClient from './api-client'

function create(email) {
  return apiClient.post('users/password-reset', { user: { email } })
}

function update(token, payload) {
  return apiClient.put('users/password-reset', {
    user: payload,
    auth: { token },
  })
}

const PasswordReset = {
  create,
  update,
}

export default PasswordReset
